'use client'

import { Breadcrumb } from '@7f-ui/components/breadcrumb/breadcrumb'

import { usePathname } from 'next/navigation'

type Props = {
  title?: string
}

export function EditorialPageBreadcrumbs({ title }: Props) {
  const pathname = usePathname() ?? ''
  const breadcrumbs = useBreadcrumbsForPath(pathname)

  if (!title) return null

  const links = [{ label: title, url: '' }]
  if (breadcrumbs) links.unshift(breadcrumbs)

  return <Breadcrumb links={links} />
}

function useBreadcrumbsForPath(path: string) {
  if (path.startsWith('/reiseziele')) {
    return { label: 'Alle Reiseziele', url: '/reiseziele/' }
  }

  if (path.startsWith('/lp/erlebnisse-anbieten')) {
    return {
      label: 'Erlebnisse anbieten',
      url: '/lp/erlebnisse-anbieten/',
    }
  }
}
